import { render, staticRenderFns } from "./MyPackage.vue?vue&type=template&id=708884d2&scoped=true"
import script from "./MyPackage.vue?vue&type=script&lang=js"
export * from "./MyPackage.vue?vue&type=script&lang=js"
import style0 from "./MyPackage.vue?vue&type=style&index=0&id=708884d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708884d2",
  null
  
)

export default component.exports